import React from 'react';
import './LoadingSpinner.scss';

const LoadingSpinner = () => {
  return (
    <div className="LoadingSpinner hmf-display-flex hmf-justify-content-center">
      <div className="LoadingSpinner-spinner" />
    </div>
  );
};

export default LoadingSpinner;
